// Tag for graphql format
const gql = String.raw;

// Commons Fragments
import { InputValueFragment, LongevityFragment } from "@PayPlans/api/fragments/commons";

export const onCreateTechnicianPayPlan = gql`
	subscription onCreateTechnicianPayPlan($locationId: String, $position: String) {
		onCreateTechnicianPayPlan(locationId: $locationId, position: $position) {
			_id
			locationId
			name
			position
			default {
				_id
				defaultValue {
					input
					value
				}
				isGuaranteedDraw
			}
			nightShiftPay {
				_id
				daysSelected
				from
				to
				isMultipleDays
				commission {
					input
					value
				}
				prorateByTimeCard
			}
			holidayPay {
				_id
				holidaysSelected {
					localHolidayName
					holidayName
					date
				}
				holidayByType
			}
			retentionPay {
				retention {
					input
					value
				}
			}
			targetedPerformanceBonus {
				_id
				departments {
					tiers {
						_id
						from {
							...InputValue
						}
						to {
							...InputValue
						}
						commissions {
							from {
								...InputValue
							}
							to {
								...InputValue
							}
							commission {
								...InputValue
							}
						}
					}
					applyTiersRetroactively
					selectedDepartment
					selectedPayType
					component
				}
				operationCodes {
					tiers {
						_id
						from {
							...InputValue
						}
						to {
							...InputValue
						}
						commissions {
							from {
								...InputValue
							}
							to {
								...InputValue
							}
							commission {
								...InputValue
							}
						}
					}
					applyTiersRetroactively
					selectedPayType
					selectedOperationCodes {
						_id
						code
						type
						pay
					}
					selectedTimeLapse
					component
				}
			}
			longevity {
				...Longevity
			}
			locked
			available
			createdAt
			createdBy {
				_id
				fullName
			}
			updatedAt
			updatedBy {
				_id
				fullName
			}
		}
	}
	${LongevityFragment}
	${InputValueFragment}
`;

export const onCloneTechnicianPayPlan = gql`
	subscription onCloneTechnicianPayPlan($locationId: String, $position: String) {
		onCloneTechnicianPayPlan(locationId: $locationId, position: $position) {
			_id
			locationId
			name
			position
			default {
				_id
				defaultValue {
					input
					value
				}
				isGuaranteedDraw
			}
			nightShiftPay {
				_id
				daysSelected
				from
				to
				isMultipleDays
				commission {
					input
					value
				}
				prorateByTimeCard
			}
			holidayPay {
				_id
				holidaysSelected {
					localHolidayName
					holidayName
					date
				}
				holidayByType
			}
			retentionPay {
				retention {
					input
					value
				}
			}
			longevity {
				...Longevity
			}
			locked
			available
			createdAt
			createdBy {
				_id
				fullName
			}
			updatedAt
			updatedBy {
				_id
				fullName
			}
		}
	}
	${LongevityFragment}
	${InputValueFragment}
`;

export const onUpdateTechnicianAvailablePayPlan = gql`
	subscription onUpdateTechnicianAvailablePayPlan($locationId: String, $_id: String, $position: String) {
		onUpdateTechnicianAvailablePayPlan(locationId: $locationId, _id: $_id, position: $position) {
			_id
			available
			name
			position
		}
	}
`;

export const onDeleteTechnicianPayPlan = gql`
	subscription onDeleteTechnicianPayPlan($locationId: String) {
		onDeleteTechnicianPayPlan(locationId: $locationId) {
			_id
			locationId
		}
	}
`;

export const onUpdateTechnicianPayPlan = gql`
	subscription onUpdateTechnicianPayPlan($locationId: String, $_id: String, $position: String) {
		onUpdateTechnicianPayPlan(locationId: $locationId, _id: $_id, position: $position) {
			_id
			locationId
			name
			position
			default {
				_id
				defaultValue {
					input
					value
				}
				isGuaranteedDraw
			}
			nightShiftPay {
				_id
				daysSelected
				from
				to
				isMultipleDays
				commission {
					input
					value
				}
				prorateByTimeCard
			}
			holidayPay {
				_id
				holidaysSelected {
					localHolidayName
					holidayName
					date
				}
				holidayByType
			}
			retentionPay {
				retention {
					input
					value
				}
				isGuaranteedDraw
			}
			longevity {
				...Longevity
			}
			locked
			available
			createdAt
			createdBy {
				_id
				fullName
			}
			updatedAt
			updatedBy {
				_id
				fullName
			}
		}
	}
	${LongevityFragment}
	${InputValueFragment}
`;
